import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const Container = Box.withConfig({
  width: 'full',
  alignItems: 'center',
  justifyContent: 'center',
});

export const Heading = withTypography({
  accessible: true,
  variant: 'headerOne',
  m: '$0',
  p: '$0',
});

export const Content = withTypography({
  accessible: true,
  variant: 'copyOne',
  textAlign: 'center',
  my: '$4',
});
